<template>
  <div class="nav-grid">
    <div class="title">常用导航</div>
    <div class="grid">
      <div v-for="(item, index) in list" :key="index" class="item" @click="handleClick(item)" :title="item.link">
        <img class="icon" :src="item.icon" />
        <span class="txt">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { apiWikiIndexV2 } from "@/api/wikiApi";

export default {
  name: "NavGrid",
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.fetchNavList();
  },
  methods: {
    async fetchNavList() {
      const { code, data } = await apiWikiIndexV2();
      if (code !== 0) return;
      const { list } = data.find(el => {
        return el.module.type === 20;
      });
      this.list = list;
    },
    handleClick(item) {
      window.open(item.link);
    }
  }
};
</script>
<style lang="less" scoped>
.nav-grid {
  border-radius: 8px;
  background-color: var(--zs-qz-card-bg);
  .title {
    color: var(--zs-qz-hot-question-title-color);
    font-size: 20px;
    line-height: 55px;
    padding-left: 24px;
    border-bottom: 1px solid var(--zs-qz-tabs-border-color);
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    padding: 12px;
    gap: 12px;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      background-color: var(--zs-qz-nav-item-bg);
      border-radius: 6px;
      padding: 10px 0;
      gap: 10px;
      .icon {
        width: 50px;
        height: 50px;
      }
      .txt {
        color: var(--zs-qz-entry-text-color);
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
}
</style>
